import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  max-width: 100%;
  margin: 0 auto;

  @media (min-width: 768px) and (max-width: 1199px) {
    width: 94vw;
    max-width: 1100px; /* Más ancho en tablet */
  }

  @media (min-width: 1200px) {
    width: 92vw;
    max-width: 1280px; /* Más ancho en desktop */
  }
`;

export const ModalBody = styled.div`
  width: 100%;
  height: 80vh;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 16px 16px 16px;
  box-sizing: border-box;

  @media (min-width: 768px) and (max-width: 1199px) {
    height: 70vh;
  }
`;

export const Controls = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const ControlButton = styled.button`
  height: 36px;
  padding: 0 12px;
  border-radius: 8px;
  color: var(--color-white);
  background: var(--color-latex30);
  border: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const IframeWrapper = styled.div`
  width: 100%;
  flex: 1;
  border-radius: 10px;
  overflow: auto; /* Permite scrollear cuando hay zoom */
  background: var(--color-white);
  box-shadow:
    rgba(0, 0, 0, 0.05) 0px 41.7776px 33.4221px,
    rgba(0, 0, 0, 0.043) 0px 22.3363px 17.869px,
    rgba(0, 0, 0, 0.035) 0px 12.5216px 10.0172px,
    rgba(0, 0, 0, 0.027) 0px 6.6501px 5.32008px,
    rgba(0, 0, 0, 0.02) 0px 2.76726px 2.21381px;
`;

export const ScaleBox = styled.div`
  width: ${(p) => `${(1 / (p.zoom || 1)) * 100}%`};
  height: ${(p) => `${(1 / (p.zoom || 1)) * 100}%`};
  transform: ${(p) => `scale(${p.zoom || 1})`};
  transform-origin: top left;
`;

export const PdfFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;
